import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { RegisterTypes } from 'models/User';

import { register, RegisterParams } from 'store/modules/user/actions';

import Component from './component';

export interface Props extends ParentProps {
    actions: {
        register: (params: RegisterParams) => Promise<any>;
    };
}

export interface ParentProps {
    onRender: (renderProps: RenderProps) => ReactNode;
    onSuccess?: (response: any) => any;
    registerType: RegisterTypes;
}

export interface RenderProps {
    onClick: () => any;
}

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            register: bindActionCreators(register, dispatch),
        },
    };
};

export interface ErrorMessages {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    userAgrees: string;
}

Component.defaultProps = {};

export default connect(null, mapDispatchToProps)(Component);